import { Paper } from '@sanlam-glacier/app-common/components';
import { SecurityAccessFeaturesEnum, StateModel } from 'bff';
import { PageHeader } from 'components/atoms/page-header/PageHeader';
import { HorizontalStepper } from 'components/molecules/horizontal-stepper/HorizontalStepper';
import { Provider } from 'jotai';
import { getStepConfig } from 'modules/new-business/utils/proposal-stepper/step-configuration';
import { DisabledFieldsProvider } from 'providers/disabled-provider/DisabledFieldsProvider';
import { useUserContext } from 'providers/managers/user-context-manager/user-context-manager';
import { Outlet } from 'react-router-dom';
import styles from './proposal-layout.module.scss';

const defaultFormState: StateModel = {
  step1: 'Default',
  step2: 'Default',
  step3: 'Default',
  step4: 'Default',
  step5: 'Default',
  step6: 'Default',
  step5SubSteps: {
    step5AppointIntermediary: 'Default',
    step5EmploymentAndTax: 'Default',
    step5PaymentMethods: 'Default',
    step5PersonalDetails: 'Default',
    step5RelatedParties: 'Default',
    step5SecondLifeDetails: 'Default',
    step5TaxDetails: 'Default',
    step5ThirdParties: 'Default',
    step5TrustAndPolicyDetails: 'Default',
    step5JustPortfolio: 'Default'
  },
  step3Scenarios: []
};

export const NewProposalLayout = () => {
  const stepConfig = getStepConfig(defaultFormState, false);
  const userContext = useUserContext();

  const userHasEditFeature =
    userContext
      .getUserFeatures()
      .findIndex((feature) => feature === SecurityAccessFeaturesEnum.EditProposal) > -1;

  const disableInputs = !userHasEditFeature;
  return (
    <DisabledFieldsProvider value={disableInputs}>
      <PageHeader>New proposal</PageHeader>

      <Paper rounding={Paper.ROUNDING.SMALL} className={styles.stepContent}>
        <Provider>
          <HorizontalStepper
            stepConfig={stepConfig}
            currentStep={1}
            isStepDisabled={(step) => step > 1}
          />
          <Outlet />
        </Provider>
      </Paper>
    </DisabledFieldsProvider>
  );
};

export default NewProposalLayout;
